import { FETCH_AI_ANALYSIS_REQUEST, FETCH_AI_ANALYSIS_SUCCESS, FETCH_AI_ANALYSIS_FAILURE } from './constants';
import { StockAnalysisData } from './types';

export interface FetchAIAnalysisRequestAction {
    type: typeof FETCH_AI_ANALYSIS_REQUEST;
    payload: string;
}

export interface FetchAIAnalysisSuccessAction {
    type: typeof FETCH_AI_ANALYSIS_SUCCESS;
    payload: StockAnalysisData;
}

export interface FetchAIAnalysisFailureAction {
    type: typeof FETCH_AI_ANALYSIS_FAILURE;
    payload: any;
}

export type AIAnalysisActions =
    | FetchAIAnalysisRequestAction
    | FetchAIAnalysisSuccessAction
    | FetchAIAnalysisFailureAction;

export const fetchAIAnalysisRequest = (payload: string): FetchAIAnalysisRequestAction => ({
    type: FETCH_AI_ANALYSIS_REQUEST,
    payload,
});

export const fetchAIAnalysisSuccess = (data: StockAnalysisData): FetchAIAnalysisSuccessAction => ({
    type: FETCH_AI_ANALYSIS_SUCCESS,
    payload: data,
});

export const fetchAIAnalysisFailure = (error: any): FetchAIAnalysisFailureAction => ({
    type: FETCH_AI_ANALYSIS_FAILURE,
    payload: error,
});
